import parser from 'ua-parser-js'
import { isBrowser } from 'env'

// https://perishablepress.com/list-all-user-agents-top-search-engines/
const botRegExps = [
  /aolbuild/i,
  /baidu/i,
  /bingbot/i,
  /bingpreview/i,
  /msnbot/i,
  /duckduckgo/i,
  /adsbot-google/i,
  /googlebot/i,
  /mediapartners-google/i,
  /teoma/i,
  /slurp/i,
  /yandex/i,
  /dotbot/i
]

export const isIPhoneX = (info) => {
  if (isBrowser()) {
    // iPhone X Detection
    // https://stackoverflow.com/questions/47226824/iphonex-and-notch-detection
    const ratio = window.devicePixelRatio || 1
    const screen = {
      width: window.screen.width * ratio,
      height: window.screen.height * ratio
    }
    if (info.browser.name === 'Mobile Safari' && screen.width === 1125 && screen.height === 2436) {
      return true
    }
  }

  return false
}

export const getUserAgent = (req) => {
  try {
    return parser(req
      ? req.get('User-Agent')
      : window.navigator.userAgent,
    // https://github.com/faisalman/ua-parser-js/issues/227
    // Add type bot
    {
      browser: botRegExps.reduce((array, regex) =>
        array.concat([[regex], [parser.BROWSER.NAME, parser.BROWSER.VERSION, ['type', 'bot']]]),
      [])
    }
    )
  } catch (_) {

  }
}

export const shouldInjectPerformanceTrackingScript = (ua) => ua && ua.browser && ua.browser.type !== 'bot' && ua.browser.name !== 'IE'

export const isBot = (req) => {
  const ua = getUserAgent(req)
  return ua && ua.browser.type === 'bot'
}

/*
  ES5 - ES8 Polyfill
  NOTED: Next.js, and polyfill.io, fail to support IE10 in this environment
  TODO: Manually import only functions that are used in this project to minimise bundle size
        OR only include this for IE
*/
export const shouldForceInjectPolyfill = (ua) => {
  return ua && ua.browser && (
    ua.browser.name === 'IE' ||
    ua.browser.name === 'Samsung Browser' ||
    ua.browser.name === 'Android Browser' ||
    (ua.browser.name === 'Mobile Safari' && +ua.browser.major <= 8)
  )
}
